// src/storage.ts
var OPS_BUCKET = "ops";
var OPS_SIGNED_URL_TTL_S = {
  /** In-app `<img>`; never leaves the operator's browser and is re-signed on remount. */
  display: 50 * 60,
  /** Link an operator copies into a message to a customer. */
  clientShare: 30 * 24 * 60 * 60,
  /** Emitted into the provider order CSV, which the provider opens days-to-weeks later. */
  providerOrder: 90 * 24 * 60 * 60
};
var OPS_PUBLIC_URL_MARKER = `/storage/v1/object/public/${OPS_BUCKET}/`;
var stripQuery = (value) => value.split("?")[0] ?? value;
var decodeKey = (value) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
var parseStoredImageRef = (stored) => {
  const markerAt = stored.indexOf(OPS_PUBLIC_URL_MARKER);
  if (markerAt !== -1) {
    return { kind: "opsPath", path: decodeKey(stripQuery(stored.slice(markerAt + OPS_PUBLIC_URL_MARKER.length))) };
  }
  if (/^https?:\/\//i.test(stored)) {
    return { kind: "foreignUrl", url: stored };
  }
  return { kind: "opsPath", path: stripQuery(stored) };
};
var opsSignedUrlExpiresAt = (audience, from = /* @__PURE__ */ new Date()) => new Date(from.getTime() + OPS_SIGNED_URL_TTL_S[audience] * 1e3);
var signOpsPath = async (client, path, audience) => {
  const { data, error } = await client.storage.from(OPS_BUCKET).createSignedUrl(path, OPS_SIGNED_URL_TTL_S[audience]);
  if (error) throw error;
  return data.signedUrl;
};
var signOpsPaths = async (client, paths, audience) => {
  if (paths.length === 0) return {};
  const { data, error } = await client.storage.from(OPS_BUCKET).createSignedUrls(paths, OPS_SIGNED_URL_TTL_S[audience]);
  if (error) throw error;
  return (data ?? []).reduce((signed, entry, index) => {
    const requested = paths[index];
    if (!requested || entry.error || !entry.signedUrl) return signed;
    return { ...signed, [requested]: entry.signedUrl };
  }, {});
};
var resolveStoredImageRef = async (client, stored, audience) => {
  if (!stored) return null;
  const ref = parseStoredImageRef(stored);
  return ref.kind === "foreignUrl" ? ref.url : signOpsPath(client, ref.path, audience);
};
export {
  OPS_BUCKET,
  OPS_SIGNED_URL_TTL_S,
  opsSignedUrlExpiresAt,
  parseStoredImageRef,
  resolveStoredImageRef,
  signOpsPath,
  signOpsPaths
};
//# sourceMappingURL=storage.js.map